<template>
  <div v-if="listShow" v-loading="loading" class="list" element-loading-text="数据获取中">
    <div class="qmContent">
      <viewer v-if="cutList.length>0" :images="cutList" class="MQcut">
        <img v-for="(img, index) in cutList" :key="index" class="uploadpic" :src="questionImgListUrl(img)" alt />
      </viewer>
      <div v-else class="MQcut">
        <el-image class="uploadpic">
          <div slot="error" class="image-slot">
            <span>暂无截图</span>
          </div>
        </el-image>
      </div>
      <el-form ref="addForm" :model="qmData" label-position="left" size="small" class="formList">
        <el-form-item label="所属文件:" label-width="75px">
          <p :title="qmData.fileName" class="content" style="color: #58667b"> {{ qmData.fileName }} </p>
        </el-form-item>
        <el-form-item label="问题状态:" label-width="75px">
          <el-dropdown 
            trigger="hover" 
            :key="qmData.questionId" 
            :ref="`popover${qmData.questionId}`"
            @command="commandStatus"
          >
            <!-- <el-form ref="formstatus" :rules="statusRules" :model="formstatus" class="statusForm" size="small"
              label-position="top">
              <el-form-item label="问题状态:" prop="statusId">
                <el-select v-model="formstatus.statusId" size="small" placeholder="请选择">
                  <el-option v-for="item in dicList.dealList" :key="item.id" :label="item.cnName" :value="item.id">
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="说明:">
                <el-input v-model="formstatus.content" placeholder="请输入说明" type="textarea" maxlength="200"
                  show-word-limit></el-input>
              </el-form-item>
              <el-form-item class="footer">
                <el-button size="small" @click="visible = false">
                  取 消
                </el-button>
                <el-button size="small" type="primary" @click="changeStatus">
                  确 定
                </el-button>
              </el-form-item>
            </el-form> -->
            <span class="changeStatus" :class="{
              status1: qmData.queStatus == '待修改',
              status2: qmData.queStatus == '已修改',
              status3: qmData.queStatus == '不修改',
              status4: qmData.queStatus == '已销项',
              }" style="cursor: pointer;">
              {{ qmData.queStatus }}
            </span>
            <el-dropdown-menu slot="dropdown" v-if="dicList.dealList && dicList.dealList.length > 0">
                 <el-dropdown-item 
                    v-for="ele in dicList.dealList" 
                    :key="ele.id" 
                    :value="ele.id" 
                    :command="{row:qmData, queStatusId: ele.id, queStatus: ele.cnName}">
                    {{ ele.cnName }}
                 </el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </el-form-item>
        <el-form-item label="问题描述:" label-width="75px">
          <p :title="qmData.checkContent" class="contentMini" @click="getPosition"> {{ qmData.checkContent }} </p>
        </el-form-item>
        <el-form-item label="审图要点:" label-width="75px">
          <p :title="qmData.drawingReviewPoints" class="contentMini"> {{ qmData.drawingReviewPoints||' ' }} </p>
        </el-form-item>
        <el-form-item class="associatedFileStyle">
          <span class="title">关联文件:</span>
          <ul>
            <li v-for="(item,index) in qmData.annexFileList" :key="index">
              <p class="fileNamestyle" :title="item.fileName" @click="preview(item)">
                {{ item.fileName }}
              </p>
              <p style="margin-top:3px">
                <img :src="down" alt="下载" style="margin-right: 15px;cursor: pointer;" @click="todown(item)">
              </p>
            </li>
          </ul>
        </el-form-item>
        <el-form-item label="问题类型:" label-width="75px">
          <p class="content"> {{ qmData.qmType }} </p>
        </el-form-item>
        <!-- <el-form-item label="严重等级:" label-width="75px">
          <p class="content"> {{ qmData.problemType }} </p>
        </el-form-item> -->
        <el-form-item v-if="stageNameBoolean" label="阶段:" label-width="75px">
          <p class="content"> {{ stageName }} </p>
        </el-form-item>
        <el-form-item v-if="childNameBoolean" label="子项:" label-width="75px">
          <p class="content"> {{ childName }} </p>
        </el-form-item>
        <el-form-item v-if="specNameBoolean" label="专业:" label-width="75px">
          <p class="content"> {{ specName }} </p>
        </el-form-item>
        <el-form-item v-if="multiSpecNameBoolean" label="跨专业:" label-width="75px">
          <p class="content"> {{ multiSpecName }} </p>
        </el-form-item>
        <el-form-item label="修改方:" label-width="75px">
          <div>
            <span v-for="(item,index) in modifierNameList" :key="index" style="margin-right: 2px">
              <img :src="item.imgUrl" class="userAvator" alt="头像" style="margin-bottom: 2px" />
              <span style="font-size:14px">{{ item.modifierName }}</span>
            </span>
          </div>
        </el-form-item>
        <el-form-item label="创建人:" label-width="75px">
          <div style="display: flex;">
            <img :src="creatorAvator" class="userAvator" alt="头像" />
            <p class="content" style="padding-left: 0;width:90%">{{ qmData.creatorName }}</p>
          </div>
        </el-form-item>
        <el-form-item label="创建时间:" label-width="75px">
          <p class="content">{{ qmData.createDate }}</p>
        </el-form-item>
        <el-form-item label="问题来源:" label-width="75px">
          <div class="content">{{ qmData.source }}</div>
        </el-form-item>
        <el-form-item label="位置:" label-width="75px">
          <div class="content" :title="qmData.textProperties">{{ qmData.textProperties }}</div>
        </el-form-item>
      </el-form>
    </div>
    <div class="footer">
      <el-button type="primary" :disabled="userId!=qmData.creatorId" size="small" @click="editForm">修 改</el-button>
    </div>
  </div>
</template>

<script>
import mongeService from "@/CommonDP/mongeView/service/monge-service";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import Vue from "vue";
Vue.use(Viewer);
import { questionImgUrl1, downloadUrltoken } from "@/CommonDP/mongeView/utils";
import { mapState } from "vuex";
import mongeCommon from "@/CommonDP/mongeView/common/mongeCommon";
import { gettouxAvatar } from '@/CommonDP/utils/index';
import { noLabelFilePreview } from "@/CommonDP/utils/docPublic";
import question from "@/xgzdService/question-service";

export default {
  props: ["questionId", "type"],
  data() {
    return {
      qmData: {},
      qsId: "",
      cutList: [],
      loading: false,
      prjId: "",
      listShow: false,

      stageName: "",
      stageNameBoolean: false,
      specName: "",
      specNameBoolean: false,
      multiSpecName: "",
      multiSpecNameBoolean: false,
      childName: "",
      childNameBoolean: false,
      modifierNameList: [],
      down: require("./../images/issueMgDown.png"),
      dicList: {
        dealList: []
      }, // 字典数据
      sharerUserId: "",
      shareId: '',
      flowInstanceId: "",
      visible: false,
      formstatus: {
        // 修改问题状态
        statusId: "", // 问题id
        content: ""
      },
      statusRules: {
        statusId: [{ required: true, message: "问题状态不可为空", trigger: "change" }]
      }
    };
  },
  computed: {
    ...mapState({
      spaceOfDwgData: (state) => state.monge.spaceOfDwgData,
      userId: (state) => state.user.userId,
      userInfo: (state) => state.user.userInfo
    }),
    picCompList() {
      return this.qmData?.screenshotFileList?.map?.(item => item.fileMd5)
    },
    // 状态字典
    statusList() {
      return this.dicList?.statusList || [];
    },
    statusParams() {
      const { statusId, content } = this.formstatus;
      const params = {
        content,
        prjId: this.qmData.prjId,
        idList: [this.qmData.questionId],
        statusId: this.qmData.queStatusId,
        statusName: this.qmData.queStatus,
        toStatusId: statusId,
        toStatusName: this.dicList.statusList.find((ele) => ele.id === statusId).cnName
      };
      return params;
    },
    creatorAvator() {
      return gettouxAvatar(this.qmData.creatorId);
    }
  },
  watch: {
    questionId() {
      this.show();
    }
  },
  mounted() {
    this.show();
  },
  methods: {
    async show() {
      this.listShow = false;
      this.qsId = this.questionId || this.$route.query.questionId;
      this.sharerUserId = this.$route.query.sharerId || "";
      this.flowInstanceId = this.$route.query.flowInstanceId || "";
      this.shareId = this.$route.query.i || "";
      await this.getDetailList();
      await this.getDicList();
      this.queryDic()
      if (this.$route.query.questionId) {
        await this.showSomething();
      }
    },
    // 获取数据
    async getDetailList() {
      this.loading = true;
      try {
        const res = await question.getDrawingQuestionDetailsLc(this.qsId, this.sharerUserId, this.flowInstanceId, this.shareId);
        this.qmData = res.data;
        this.prjId = this.qmData.prjId;
        this.dealStatus()
        this.$parent.rowData = res.data;
        this.modifierNameList = [];
        this.qmData.modifierList.forEach((element) => {
          this.$set(element, 'imgUrl', gettouxAvatar(element.modifierId));
        });
        this.modifierNameList = this.qmData.modifierList;
        this.prjId = this.qmData.prjId;
        if(this.picCompList) {
          if (this.qmData.autoScreenshotMd5) {
            this.cutList = [this.qmData.autoScreenshotMd5, ...this.picCompList];
          } else {
            this.cutList = [...this.picCompList];
          }
        }
        
        if (this.qmData.specStageChildVos.some((ele) => ele.name == "阶段")) {
          this.stageNameBoolean = true;
          this.stageName = this.qmData.specStageChildVos.find((ele) => ele.name == "阶段").value;
        } else {
          this.stageNameBoolean = false;
          this.stageName = "";
        }
        if (this.qmData.specStageChildVos.some((ele) => ele.name == "专业")) {
          this.specNameBoolean = true;
          this.specName = this.qmData.specStageChildVos.find((ele) => ele.name == "专业").value;
        } else {
          this.specNameBoolean = false;
          this.specName = "";
        }
        if (this.qmData.specStageChildVos.some((ele) => ele.name == "跨专业")) {
          this.multiSpecNameBoolean = true;
          this.multiSpecName = this.qmData.specStageChildVos.find((ele) => ele.name == "跨专业").value;
        } else {
          this.multiSpecNameBoolean = false;
          this.multiSpecName = "";
        }
        if (this.qmData.specStageChildVos.some((ele) => ele.name == "子项")) {
          this.childNameBoolean = true;
          this.childName = this.qmData.specStageChildVos.find((ele) => ele.name == "子项").value;
        } else {
          this.childNameBoolean = false;
          this.childName = "";
        }

        this.listShow = true;
        this.loading = false;
      } catch (error) {
        this.loading = false;
      }
    },
    // 获得字典数据
    async getDicList() {
      const params = {
        prjId: this.qmData.prjId,
        userId: this.sharerUserId
      };
      const res = await mongeService.getDicList(params);
      this.dicList = res.data;
    },
    // 有问题id进行定位
    async showSomething() {
      if (this.type == "pdf") {
        const anchorPoint = this.qmData.anchorPoint;
        const ifreamBox = this.$parent.$parent.$parent.$parent.$refs.iframeID;
        const { PDFViewerApplication } = ifreamBox.contentWindow;
        PDFViewerApplication.page = Number(anchorPoint) || 1;
      } else if (this.type == "dwg" || this.type == "model") {
        await this.$nextTick()
        mongeCommon.fitToQs(this.qmData, this.statusList, this.type);
      }
    },
    questionImgListUrl(fileMD5) {
      if (!fileMD5) {
        return;
      }
      return questionImgUrl1(fileMD5);
    },
    editForm() {
      this.$emit("openEdit");
    },
    getPosition(){
      this.$emit("getPosition",this.qmData.checkContent);
    },
    todown(row) {
      const prjId = this.$route.query.prjId || this.prjId;
      const fileId = row.fileId;
      window.location = downloadUrltoken(prjId, fileId, this.sharerUserId);
    },
    dealStatus() {
      const { creatorId, queStatus, modifierList } = this.qmData;
      this.visible = true;
      this.currentUserID = this.userInfo.userId;
        let list = this.dicList.statusList ? this.dicList.statusList : []
      if (creatorId == this.currentUserID && modifierList.some((ele) => ele.modifierId == this.currentUserID)) {
        // 同一个人
        if (queStatus == "待修改") {
          this.dicList.dealList = list.filter((ele) => ele.cnName == "已修改" || ele.cnName == "已取消");
        } else if (queStatus == "已修改") {
          this.dicList.dealList = list.filter((ele) => ele.cnName == "已复核" || ele.cnName == "待修改" || ele.cnName == "已取消");
        } else if (queStatus == "已复核") {
          this.dicList.dealList = list.filter((ele) => ele.cnName == "待修改" || ele.cnName == "已取消");
        } else if (queStatus == "已取消") {
          this.dicList.dealList = list.filter((ele) => ele.cnName == "待修改");
        }
      } else {
        // 创建人
        if (creatorId == this.currentUserID) {
          if (queStatus == "待修改") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "已取消");
          } else if (queStatus == "已修改") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "已复核" || ele.cnName == "待修改" || ele.cnName == "已取消");
          } else if (queStatus == "已复核") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "待修改" || ele.cnName == "已取消");
          } else if (queStatus == "已取消") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "待修改");
          }
        } else if (modifierList.some((ele) => ele.modifierId == this.currentUserID)) {
          // 处理人
          if (queStatus == "待修改") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "已修改" || ele.cnName == "已取消");
          } else if (queStatus == "已修改") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "待修改" || ele.cnName == "已取消");
          } else if (queStatus == "已复核") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "已取消");
          } else if (queStatus == "已取消") {
            this.dicList.dealList = list.filter((ele) => ele.cnName == "待修改");
          }
        } else {
          this.visible = false;
          // this.$message.warning("很抱歉,仅问题创建人或者问题处理人有修改问题状态的权限");
        }
      }
    },
    async changeStatus() {
      this.$refs.formstatus.validate(async (valid) => {
        if (valid) {
          try {
            const res = await mongeService.drawingannotationupdateStatus(this.statusParams);
            if (res.result == "0") {
              this.$message.success("修改成功");
              this.visible = false;
              await this.getDetailList();
            }
          } catch (error) {
            this.visible = false;
          }
        }
      });
    },
    preview(row) {
      const prjId = this.$route.query.prjId || this.prjId;
      var row1 = {
        folderId: row.fileId,
        folderName: row.fileName,
        fileVersion: row.fileVersion,
        prjId,
        fileType: row.fileType,
        status: row.status
      };
      noLabelFilePreview(row1, prjId, "", "ct", '');
    },
    async commandStatus({row,queStatusId, queStatus}) {
      this.dataRow = row;
      this.dataRow.toStatusId = queStatusId;
      this.dataRow.toStatusName = queStatus;
      const res = await question.drawingannotationupdateStatus(
              this.statusParams
      );
      if (res.result == "0") {
              this.$message.success("修改成功");
              this.formstatus.statusId = "";
              this.formstatus.content = "";
              this.nolist = [];
              this.queryNotationList();
              this.isRead = true;
      }
    },
    // 查询时候的字典
    async queryDic() {
      const res = await mongeService.getFilterDic(this.prjID, this.sharerUserId, this.flowInstanceId);
      this.dicList = res.data || {};
    },
  }
};
</script>

<style lang="scss" scoped>
.list {
  width: 100%;
  height: 100%;
  padding: 10px 0 10px 10px;
  .qmContent {
    width: 100%;
    height: calc(100% - 50px);
    padding-right: 10px;
    overflow-y: auto;
    /deep/ .el-form-item {
      margin-bottom:5px
    }
    /deep/.el-form-item__label {
      font-size: 14px;
      line-height: 30px;
      height: 30px;
      user-select: none;
    }
    .content {
      padding: 5px 0 5px 5px;
      user-select: none;
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      max-height: 85px;
      min-height: 20px;
      color: var(--key-color);
      overflow: hidden;
      text-overflow: ellipsis;
      white-space: nowrap;
    }
    .contentMini {
      padding: 5px 0 5px 5px;
      user-select: none;
      width: 100%;
      font-size: 14px;
      line-height: 20px;
      min-height: 20px;
      color: #58667b;
      word-wrap: break-word;
    }
    .associatedFileStyle {
      .title{
        font-size: 14px;
        line-height: 30px;
        height: 30px;
        user-select: none;
      }
      li {
        display: flex;
        justify-content: space-between;
        color: var(--theme-color);
        user-select: none;
      }
      .fileNamestyle {
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
        max-width: 330px;
        padding-left: 5px;
      }
      li:hover {
        background: #eef1ff;
      }
    }
    .userAvator {
      border-radius: 50%;
      width: 32px;
      height: 30px;
      margin-top: 0px;
      display: inline-block;
      vertical-align: top;
    }
  }
  .footer {
    width: 100%;
    height: 50px;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 5px;
    .el-button {
      width: 90%;
      height: 100%;
    }
  }
  .MQcut {
    width: 100%;
    height: 80px;
    display: flex;
    flex-direction: row;
    align-items: center;
    .uploadpic {
      width: 75px;
      height: 75px;
      margin-right: 5px;
      cursor: pointer;
      /deep/.image-slot {
        width: 75px;
        height: 75px;
        line-height: 75px;
        background: rgb(239, 239, 239);
        color: rgb(153, 153, 153);
        text-align: center;
      }
    }
  }
  .formList {
    width: 100%;
    height: calc(100% - 80px);
    .statusForm {
      padding: 5px 15px;
      box-sizing: border-box;
    }
    .changeStatus {
      cursor: pointer;
      padding: 5px 10px;
      border-radius: 50px;
    }
    .status1{
      color:#eb5757;
    }
    .status2{
      color:#eac100;
    }
    .status3{
      color:#979797;
    }
    .status4{
      color: #00B632
    }
  }
}
</style>
